require('./js/angular-tablesort');
module.exports = 'tableSort';